export default "__VITE_ASSET__Ce5I64tg__"